import React from 'react';
import styled from 'styled-components';

import Icon from 'js/components/common/Icon';
import { primaryColor } from 'js/config/style';

export default styled(({ className, name }) => <Icon className={className} name={name ? name : 'info-circle'} />)`
  color: ${({ color }) => (color ? color : primaryColor)};
  position: absolute;
  left: 0;
  top: 0;
  font-size: 1.875rem;
  line-height: 1.5rem;
  margin-right: 0.5rem;
`;
